import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { SelectInactiveOfficesToRenewResponseModel } from '../../../model/selectInactiveOfficesToRenewResponseModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';
import { EntityRenewalService } from '../entity-renewal.service';
import { Router } from '@angular/router';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import * as $ from 'jquery';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { StorageService } from '../../../shared/security/StorageService';
import { SectionTextModel } from '../../../model/sectionTextModel';
import { SectionContentModel } from '../../../model/sectionContentModel';
import { IndividualRenewalService } from '../../individual-renewal/individual-renewal.service';
import { SubmitIndividualCorporationStatusResponseModel } from '../../../model/submitIndividualCorporationStatusResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { CompleteFunctionRequestModel } from '../../../model/completeFunctionRequestModel';
import { CompleteFunctionService } from '../../../shared/utils/complete-function.service';
import { MessageModel } from '../../../model/models';

@Component({
  selector: 'app-review-entity-renewal',
  templateUrl: './review-entity-renewal.component.html',
  styleUrls: ['./review-entity-renewal.component.css']
})
export class ReviewEntityRenewalComponent implements OnInit, OnDestroy {

  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel = new WorkflowModel();
  completeFunctionRequest: CompleteFunctionRequestModel;
  userMessages: Array<MessageModel> = [];

  notifySubmitQuestionnaireAnswersSubscription: Subscription = new Subscription();
  notifyEntityQuestionListSubscription: Subscription = new Subscription();
  notifyIndividualQuestionListSubscription: Subscription = new Subscription();
  notifySelectInactiveOfficesToRenewSubscription: Subscription = new Subscription();
  submitIndividualQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();
  entityRenewalQuestions: Array<QuestionnaireQuestionModel> = [];
  individualRenewalQuestions: Array<QuestionnaireQuestionModel> = [];
  selectInactiveOfficesToRenewResponseModel: SelectInactiveOfficesToRenewResponseModel = new SelectInactiveOfficesToRenewResponseModel();
  headerContent: SectionContentModel = new SectionContentModel;
  notifyIndividualCorporationStatusResponseSubscription = new Subscription();
  individualCorporationStatusResponse: SubmitIndividualCorporationStatusResponseModel = new SubmitIndividualCorporationStatusResponseModel();

  notifySubmitEntityQuestionnaireAnswersSubscription: Subscription = new Subscription();
  submitEntityQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();

  constructor(private entityRenewalService: EntityRenewalService,
    private individualRenewalService: IndividualRenewalService,
    private router: Router,
    private startFunctionService: StartFunctionService,
    private currentPageWatcher: CurrentPageWatcherService,
    private completeFunctionService: CompleteFunctionService,
    private storage: StorageService) {

   

    let textModel: SectionTextModel = new SectionTextModel();
    textModel.text = "Please review the following information that you submitted for your renewal. If you need to make any changes click the Back button to reach the page you need to make changes for. After you have verified the information click the Continue button.";
    this.headerContent.textList.push(textModel);

    this.currentPageWatcher.sendHeaderContent(this.headerContent);

    this.notifyIndividualCorporationStatusResponseSubscription = this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().subscribe(
      (data: SubmitIndividualCorporationStatusResponseModel) => {
        this.individualCorporationStatusResponse = data;

      }
    );
    this.notifySubmitQuestionnaireAnswersSubscription = this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().subscribe(submitQuestionnaireAnswersResp => {
      this.submitIndividualQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;

    });

    this.notifyEntityQuestionListSubscription = this.entityRenewalService.getNotifyQuestionList().subscribe(questionListData => {
      this.entityRenewalQuestions = questionListData;
    });

    this.notifyIndividualQuestionListSubscription = this.individualRenewalService.getNotifyIndividualQuestionList().subscribe(questionListData => {
      this.individualRenewalQuestions = questionListData;
    });

    this.notifySelectInactiveOfficesToRenewSubscription = this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().subscribe(
      selectInactiveOfficesData => {
        this.selectInactiveOfficesToRenewResponseModel = selectInactiveOfficesData;

      });

    this.notifySubmitEntityQuestionnaireAnswersSubscription = this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().subscribe(submitQuestionnaireAnswersResp => {
      this.submitEntityQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;

    });

  }

  ngOnInit() {
    this.startFunction = this.storage.getStartFunctionData();

    if(this.entityRenewalService.renewalWorkflowModel == undefined || this.entityRenewalService.renewalWorkflowModel==null){
      this.workflow = this.startFunction.Workflow;
    }
    else{
      this.workflow = this.entityRenewalService.renewalWorkflowModel;
    }
    // if (this.submitEntityQuestionnaireAnswersResponseModel.Workflow == null && this.selectInactiveOfficesToRenewResponseModel.Workflow == null && this.individualCorporationStatusResponse.Workflow == null && this.submitIndividualQuestionnaireAnswersResponseModel.Workflow != null) {
    //   this.workflow = this.submitIndividualQuestionnaireAnswersResponseModel.Workflow;
    // }

    // if (this.submitEntityQuestionnaireAnswersResponseModel.Workflow == null && this.selectInactiveOfficesToRenewResponseModel.Workflow == null && this.individualCorporationStatusResponse.Workflow != null) {
    //   this.workflow = this.individualCorporationStatusResponse.Workflow;
    // }

    // if (this.submitEntityQuestionnaireAnswersResponseModel.Workflow == null && this.selectInactiveOfficesToRenewResponseModel.Workflow != null) {
    //   this.workflow = this.selectInactiveOfficesToRenewResponseModel.Workflow;
    // }

    // if (this.submitEntityQuestionnaireAnswersResponseModel.Workflow != null) {
    //   this.workflow = this.submitEntityQuestionnaireAnswersResponseModel.Workflow;
    // }

    // if (this.submitEntityQuestionnaireAnswersResponseModel.Workflow == null && this.selectInactiveOfficesToRenewResponseModel.Workflow == null && this.individualCorporationStatusResponse.Workflow == null && this.submitIndividualQuestionnaireAnswersResponseModel.Workflow == null) {
    //   this.workflow = this.startFunction.Workflow;
    // }

    console.log("workflow from review : ", this.workflow);
  }

  continue() {
    this.currentPageWatcher.sendUserMessages(null);
    this.currentPageWatcher.clearHeaderContent();
    this.completeFunctionRequest = new CompleteFunctionRequestModel();
    this.completeFunctionRequest.WorkflowID = this.workflow.WorkflowID;
    this.completeFunctionRequest.CurrentStepIndex = this.workflow.CurrentStepIndex;
    this.completeFunctionRequest.OrderNumber = null;


    if ((this.workflow.Fees.length != 0) && (this.workflow.Fees.length != null)) {
      this.router.navigate(["/renewalPay"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(true);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(this.submitEntityQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
        this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalQuestions);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);

      })
    }
    else {
      this.completeFunctionService.completeFunction(this.completeFunctionRequest).subscribe(completeFunctionResp => {
        console.log("completeFunctionResp:  ", completeFunctionResp);
        if (completeFunctionResp.UserMessages != undefined) {
          completeFunctionResp.UserMessages.forEach(el => {
            this.userMessages.push(el);
          });
        }
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        if (completeFunctionResp.Summary == 0) {
          this.entityRenewalService.renewalWorkflowModel = completeFunctionResp.Workflow;
          //save startFunction with updated workflow in localstorage
          this.startFunction.Workflow.CurrentStepIndex = (this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex ? this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex : null);
          this.startFunction.Workflow.WorkflowID = (this.entityRenewalService.renewalWorkflowModel.WorkflowID ? this.entityRenewalService.renewalWorkflowModel.WorkflowID : null);
          this.startFunction.Workflow.WorkflowDisplayName = (this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName ? this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName : null);
          this.startFunction.Workflow.Fees = (this.entityRenewalService.renewalWorkflowModel.Fees ? this.entityRenewalService.renewalWorkflowModel.Fees : null);
          for (let i = 0; i < this.entityRenewalService.renewalWorkflowModel.Steps.length; i++) {
            this.startFunction.Workflow.Steps[i].StepDisplayName = this.entityRenewalService.renewalWorkflowModel.Steps[i].StepDisplayName;
            this.startFunction.Workflow.Steps[i].StepMessage = this.entityRenewalService.renewalWorkflowModel.Steps[i].StepMessage;
            this.startFunction.Workflow.Steps[i].WorkflowStepStatus = this.entityRenewalService.renewalWorkflowModel.Steps[i].WorkflowStepStatus;
            this.startFunction.Workflow.Steps[i].WorkflowStepType = this.entityRenewalService.renewalWorkflowModel.Steps[i].WorkflowStepType;

          }
          this.storage.setStartFunctionData(this.startFunction);

          this.router.navigate(['/renewalReceipt']).then(() => {
            this.startFunctionService.getNotifyStepInProgress().emit(true);
            this.completeFunctionService.getNotifyCompleteFunctionResponse().emit(completeFunctionResp);
            this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
            this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
            this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(this.submitEntityQuestionnaireAnswersResponseModel);
            this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
            this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalQuestions);
            this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
          });
          this.userMessages = [];
        }
        if (completeFunctionResp.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        }
        if (completeFunctionResp.Summary == 2) {
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      });

    }

  }
  goBack() {
    this.currentPageWatcher.clearHeaderContent();
    // entity renewal review step WorkflowStepType = 20
    // individual renewal review step WorkflowStepType = 20
    let currentStep =  this.workflow.Steps.indexOf(this.workflow.Steps.filter(el=>el.WorkflowStepType == 46)[0]) != -1 ? this.workflow.Steps.indexOf(this.workflow.Steps.filter(el=>el.WorkflowStepType == 46)[0]) : this.workflow.Steps.indexOf(this.workflow.Steps.filter(el=>el.WorkflowStepType == 20)[0]);
    console.log(currentStep);
    // let currentStepIndex = this.workflow.Steps
    if (this.workflow.Steps[currentStep - 1].WorkflowStepType == 18) {
      //verifyIndividualRenewalQuestionnaire
      this.router.navigate(["/verifyIndividualRenewalQuestionnaire"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
      })
    }

    if (this.workflow.Steps[currentStep - 1].WorkflowStepType == 50) {
      //individualCorporation
      this.router.navigate(["/individualCorporation"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
      })
    }

    if ((this.workflow.Steps[currentStep - 1].WorkflowStepType == 52) || (this.workflow.Steps[currentStep - 1].WorkflowStepType == 39)) {
      //inactiveOfficesToRenew
      this.router.navigate(["/inactiveOfficesToRenew"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(this.submitEntityQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalQuestions);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
        this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
      })
    }
    if ((this.workflow.Steps[currentStep - 1].WorkflowStepType == 55) || (this.workflow.Steps[currentStep - 1].WorkflowStepType == 44) || (this.workflow.Steps[currentStep - 1].WorkflowStepType == 39)) {
      //entityCorporation
      this.router.navigate(["/entityCorporation"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(this.submitEntityQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalQuestions);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
        this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
      })
    }
  }

  //back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.goBack();
  }
  ngOnDestroy(): void {
    this.currentPageWatcher.clearHeaderContent();
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }

}
;


// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/review-entity-renewal/review-entity-renewal.component.ts